
<div class="products-list" *ngIf="!loading " >
  <div
    *ngFor="let product of products | paginate:  { itemsPerPage: productsCountOnPage, currentPage: page, totalItems: total  }"
    class="product-item">

    <product-item [product]="product"></product-item>

  </div>



</div>
<div *ngIf="products.length == 0 && !loading" class="not-found">По Вашему запросу ничего не найдено</div>

<pagination-controls *ngIf="products && showPagination && !loading &&  total > productsCountOnPage" class="pagination"
                     previousLabel=""
                     nextLabel=""
                     (pageChange)="change($event);setBaseScrollPosition()"
>

</pagination-controls>

<div class="spinner" *ngIf="loading" >
  <mat-spinner></mat-spinner>

</div>
